import exemption from "./itdeclarations/exemption.js";
import otherincome from "./itdeclarations/otherincome.js";
import deduction from "./itdeclarations/deduction.js";
export default {
    namespaced: true,
    modules: {
        exemption: exemption,
        otherincome: otherincome,
        deduction: deduction
    }
}